import * as React from 'react';
import Button from '../../../../../../components/common/Button';

import './BoxInfo.scss';
import RadioButton from 'src/components/common/RadioButton';
import Dropdown from 'src/components/common/Dropdown';
import UserModel from 'src/model/user.model';
import Alert from 'src/components/common/Alert';
import isNumber from 'src/utils/isNumber';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import returnsServiceInstance from 'src/services/returns/returnsService';
import env from 'src/shared/env';

export const SELF_SHIPPING = 'selfShipping';
export const PURCHASE_PREPAID_SHIPPING = 'purchasePrepaidShipping';

interface IShippingOptionsProps {
  distributionSelectedOption: string;
  handleDistributionChangeOption: (e: any) => void;
  rmaSelected: string;
  handleGenerateShippingLabel:(e:any,toShippingWarehouseCode:string)=>void;
  userData:any;
  totalItemPrice:number;
  upsErrorMessage:string;
  isLoader:boolean;
  shippingType:string;
  handleConfirmationCancel: (e:any)=>void;
  handleBoxeChange: (e:boolean)=> void;
  t?: any;
}
const BoxInfo: React.FC<IShippingOptionsProps> = props => {
  const {
    rmaSelected,
    distributionSelectedOption,
    handleDistributionChangeOption,
    handleGenerateShippingLabel,
    userData,
    totalItemPrice,
    upsErrorMessage,
    isLoader,
    shippingType,
    handleConfirmationCancel,
    handleBoxeChange,
    t
  } = props;
const [inputList, setInputList] = React.useState([]);
const [upsBoxDimensionError, setUpsBoxDimensionError] = React.useState<boolean>(false);
const [boxToshift, setBoxToShift] = React.useState([{sr:"0",val:" Select Box "},{sr:"1",val:" 1 Box "},{sr:"2",val:" 2 Boxes "},{sr:"3",val:" 3 Boxes "},{sr:"4",val:" 4 Boxes "},{sr:"5",val:" 5 Boxes"},{sr:"6",val:" 6 Boxes "},{sr:"7",val:" 7 Boxes "},{sr:"8",val:" 8 Boxes "},{sr:"9",val:" 9 Boxes "},{sr:"10",val:" 10 Boxes "}]);
const [boxToShow, setBoxToShow] = React.useState<boolean>(false);
const [upsToAddress,setUpsToAddress]=React.useState([]);
const [upsAPINetworkIssuError, setUpsAPINetworkIssuError] = React.useState<boolean>(false);
const [calculateTotalShippingCharge, setCalculateTotalShippingCharge] = React.useState<number>(0);
const [disableConfirmButton, setDisableConfirmButton] = React.useState<boolean>(false);
const [boxFixedPrice, setboxFixedPrice] = React.useState<number>(19.95);

React.useEffect(()=>{
  const newStoreList: any = [];
  returnsServiceInstance.getUpsSyncedLocations(userData.billingAddress.postalCode).then(async response => {
    response.upsEnabledWarehousesList.map((address: any,index:number) => {
      if(index===0){
        newStoreList.push({
        warehouseCode:address.warehouseCode,
        city: address.city,
        countryCode: address.countryCode,
        name: "Reliable Parts Inc.",
        postalCode: address.postalCode,
        state: address.state,
        address:address.address,
        streetName:address.streetName,
        streetNumber:address.streetNumber,
        phoneNumber:address.phoneNumber,
        areaCode:address.areaCode,
      });
    }
    });
    if(newStoreList.length===0){
      setUpsAPINetworkIssuError(true);
    }else{
      setUpsToAddress(newStoreList);
    }
  }).catch(error => {
    setUpsAPINetworkIssuError(true);
  });
},[]);

  const getSelectedOption = () => {
    const options = {
      selfShipping: false,
      purchasePrepaidShipping: false
    };

    options[distributionSelectedOption] = true;
    return options;
  };

  const selection = getSelectedOption();
 
  const handleLengthInputChange = (e: any,i:any) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[i][name] = value;
    if(isNumber(value)){
    setInputList(list);
    }
  };
  const handleWidthInputChange = (e: any,i:any) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[i][name] = value;
    if(isNumber(value)){
    setInputList(list);
    }
  };

  const handleHeightInputChange = (e: any,i:any) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[i][name] = value;
    if(isNumber(value)){
    setInputList(list);
    }
  };

  const handleWeightInputChange = (e: any,i:any) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[i][name] = value;
    if(isNumber(value)){
    setInputList(list);
    }
  };


  // handle click event of the Remove button
  const handleRemoveClick = (i: any) => {
    const list = [...inputList];
    list.splice(i, 1);
    setInputList(list);
  };
 
  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { boxLength: "", boxWidth: "",boxHeight:"",boxWeight:""  }]);
  };

  const handleBoxesToShip=(e:any)=>{
   const inputListArr:any=[]; 
    setBoxToShow(true);
    if(e>0){
    for(let i=1; i<=e; i++){
      inputListArr.push( { boxLength: "5", boxWidth: "2",boxHeight:"7",boxWeight:"2"  });
    }
    setInputList(inputListArr);
    /* Calculate TotalShipping Charge */
   }
   setCalculateTotalShippingCharge(boxFixedPrice*e);

   const refundSAmout=totalItemPrice-(boxFixedPrice*e);
   if(refundSAmout<0){
    setDisableConfirmButton(true);
    handleBoxeChange(false);
   }else{
    setDisableConfirmButton(false);
    handleBoxeChange(true);
   }
  }

 
   const handleClickGenerateShippingLabel = () => {
   setBoxToShow(false); 
   const upsBoxInputArr: any=[];
   const upsBoxInputArrEmpty: any=[];
   let toShippingWarehouseCode:string;
   let userDataPhoneNumber="";
   let userDataCountryCode="";
   let userDataAreaCode="";
   
    inputList.forEach(el => {
      if(el.boxLength==="" || el.boxWidth==="" || el.boxHeight==="" || el.boxWeight===""){
        upsBoxInputArrEmpty.push(1);
      }else{
        let toAddrCountryCode='';
        if(env.REACT_APP_BASE_ENVIRONMENT === 'US'){
         toAddrCountryCode="US";
        }else{
         toAddrCountryCode="CA";
        }
        if(userData.mobileNumber!==""){
          userDataPhoneNumber=userData.mobileNumber.toString().slice(-7);
          const firstUserPhoneNumber= userData.mobileNumber.toString().slice(0,1);
          if(firstUserPhoneNumber==="+"){
            userDataCountryCode=userData.mobileNumber.toString().slice(1,2);
            userDataAreaCode=userData.mobileNumber.toString().slice(2,5);
          }else{
            userDataCountryCode=userData.mobileNumber.toString().slice(0,1);
            userDataAreaCode=userData.mobileNumber.toString().slice(1,4);
          }
        }else{
          userDataPhoneNumber="6636060";
          userDataCountryCode="1";
          userDataAreaCode="800";
        }
       
        const shpFromArr = {
         city: userData.billingAddress.addressLine4,
         countryCode: toAddrCountryCode,
         name: userData.billingAddress.name,
         postalCode: userData.billingAddress.postalCode,
         // postalCode: "9820dsdsd1",
         state: userData.billingAddress.stateCode,
         address: `${userData.billingAddress.addressLine1} ${userData.billingAddress.addressLine2} ${userData.billingAddress.addressLine3}`,
         streetName:userData.billingAddress.addressLine1,
         streetNumber:userData.billingAddress.addressLine1.split(" ")[0],
         emailAddress:userData.email,
         phoneNumber:{
          countryCode:userDataCountryCode,
          areaCode:userDataAreaCode,
          phone:userDataPhoneNumber
         }
       };

       /* Get UPS Synced nearest warehouse */
         const shpToArr = {
         warehouseCode: upsToAddress[0].warehouseCode,
         city: upsToAddress[0].city,
         countryCode: toAddrCountryCode,
         name: upsToAddress[0].name,
         postalCode: upsToAddress[0].postalCode,
         state: upsToAddress[0].state,
         address: upsToAddress[0].address,
         streetName: upsToAddress[0].streetName,
         streetNumber: upsToAddress[0].streetNumber,
         phoneNumber:{
          countryCode:"1",
          areaCode:upsToAddress[0].areaCode,
          phone:upsToAddress[0].phoneNumber
         }
       }; 
       /* rmaNumber will be replaced by generated rmaNumber */
       el["rmaNumber"]="";
       el["shipFromAddress"]=shpFromArr;
       el["shipToAddress"]=shpToArr;
       upsBoxInputArr.push(el);
    }
    });
    if(upsBoxInputArrEmpty.length>0){
      setUpsBoxDimensionError(true);
    }else{
    /* Send info alone with toWareouseCode to generate shipping - 069 is not being used remove it */  
    toShippingWarehouseCode="069";
    handleGenerateShippingLabel(upsBoxInputArr,toShippingWarehouseCode);
    }
  };

  const handleCloseError = () => {
    setUpsBoxDimensionError(false);
  };

  const getEstimatedRefundAmount = () => {
    const refundSAmout=totalItemPrice-calculateTotalShippingCharge;
    return refundSAmout;
  };
  const estimatedRefundAmout=getEstimatedRefundAmount();


  const isDisabled = (): boolean => {
    return (
      disableConfirmButton  && (shippingType==="PREPAID_SHIPPING" || upsAPINetworkIssuError)
    );
  };

  return (
    <div className="rp-returns-table">
      {upsBoxDimensionError &&
      <Alert
          type="error"
          styleClass="rp-return-ups-info--error-alert"
          icon={'icon="rpds-check-circle"'}
          handleCloseAlert={handleCloseError}
          message={t('myReturns.dimensionError')}
        />
      }
      {upsErrorMessage!=="" &&
      <Alert
      type="error"
      styleClass="rp-return-ups-info--error-alert"
      icon={'icon="rpds-check-circle"'}
      handleCloseAlert={handleCloseError}
      message={upsErrorMessage}
    />
      }

      {upsAPINetworkIssuError &&
      <Alert
      type="error"
      styleClass="rp-return-ups-info--error-alert"
      icon={'icon="rpds-check-circle"'}
      handleCloseAlert={handleCloseError}
      message={t('myReturns.apiIssue')}
    />
      }


      {totalItemPrice>boxFixedPrice ?(
      <React.Fragment>
            <div className="container-fluid">
            <div className="rp-returns-options-box-info">
            <div className="rp-returns-options-existing">
            {t('myReturns.noBoxSelection')} :
            </div>
           
           <div className="rp-returns-box-info-dropdown">
            <Dropdown
              options={boxToshift.map(res => ({ label: res.sr!=="0" && res.sr!=="10"? res.val.substring(0,2)+"\xa0\xa0" + res.val.substring(2): res.val, value: res.sr }))}
              disabled={null}
              onSelected={handleBoxesToShip}
              activeOption={null}
              />
            </div>
           

         </div> 
         </div>
         {calculateTotalShippingCharge >0 && 
         <div className="container-fluid">
            <div className="d-flex align-items-center col-12">
              <p className="confirm-box-total"><strong>Total Shipping Charge {currencyFormatter(calculateTotalShippingCharge)}</strong></p>
            </div>

            <div className="d-flex align-items-center col-12">
              <p className="confirm-box-total"><strong>Estimated Refund Amount {currencyFormatter(estimatedRefundAmout)}</strong></p>
            </div>
            {estimatedRefundAmout <0 &&
            <div className="d-flex align-items-center col-12">
              <p className='confirm-box-total red-text'>{t('myReturns.nagativeRetunMsg')}</p>
            </div>
            }
         </div>
          }

       {boxToShow &&  
       <React.Fragment>
      <div className="container-fluid">
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.cancel')}
            action={handleConfirmationCancel}
          />
        </button>  
      {estimatedRefundAmout > 0 &&  
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.confirm')}
            action={handleClickGenerateShippingLabel}
            disabled={isDisabled()}
          />
        </button>
      } 
      </div>
      </React.Fragment>
      }
      </React.Fragment>  
       ):(
        <Alert
          type="error"
          styleClass="rp-return-ups-info--error-alert"
          icon={'icon="rpds-check-circle"'}
          handleCloseAlert={handleCloseError}
          message={`Total item price should be greater than ${currencyFormatter(boxFixedPrice)}`}
        />
      )}
    </div>
   
  );
};

export default BoxInfo;
